<template>
	<div>
		<h1>This response type has no options</h1>
	</div>
</template>

<script>
	export default {}
</script>
